import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import {
	Typography,
	Flex,
	Button,
	notification,
	Statistic,
	Modal,
	Checkbox,
} from "antd";
import { CustomTable } from "../utils/CustomComponents";
import {
	RetweetOutlined,
	PlusCircleFilled,
	EyeFilled,
} from "@ant-design/icons";
import dayjs from "dayjs";
import QAQCAddNotQCDataInternal from "./QAQCAddNotQCDataInternal";

const { Text } = Typography;

const QAQCLoadsNotQC = ({
	openModalNotQC,
	setOpenModalNotQC,
	selectedJob,
	setSelectedJob,
}) => {
	const [loadingTable, setLoadingTable] = useState(false);
	const [loadList, setLoadList] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [refresh, setRefresh] = useState(false);
	const [openModalForm, setOpenModalForm] = useState(false);
	const [load, setLoad] = useState(null);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columnsLoads = [
		{
			title: "Ticket",
			dataIndex: "ticket",
			key: "ticket",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Truck",
			dataIndex: "truck",
			key: "truck",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Loaded",
			dataIndex: "loaded",
			key: "loaded",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Arrival",
			dataIndex: "arrival",
			key: "arrival",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Ambient",
			dataIndex: "ambient",
			key: "ambient",
			render: (value) => {
				return (
					<Statistic
						value={value}
						valueStyle={{
							fontSize: 14,
						}}
					/>
				);
			},
		},
		{
			title: "Wind",
			dataIndex: "wind",
			key: "wind",
			render: (value) => {
				return (
					<Statistic
						value={value}
						valueStyle={{
							fontSize: 14,
						}}
					/>
				);
			},
		},
		{
			title: "Water",
			dataIndex: "water",
			key: "water",
			render: (value) => {
				return (
					<Statistic
						value={value}
						valueStyle={{
							fontSize: 14,
						}}
					/>
				);
			},
		},
		{
			title: "QC Type",
			dataIndex: "qcType",
			key: "qcType",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
		{
			title: "Tested",
			dataIndex: "tested",
			key: "tested",
			render: (value) => {
				return <Checkbox checked={value} />;
			},
		},
		{
			title: "Actions",
			dataIndex: "action",
			key: "action",
			render: (value, record) => {
				return (
					<Button
						type="primary"
						size="small"
						icon={record.tested ? <EyeFilled /> : <PlusCircleFilled />}
						onClick={() => {
							setOpenModalForm(true);
							setLoad(record);
						}}
					/>
				);
			},
		},
	];

	useEffect(() => {
		if (selectedJob) getLoadList();
	}, [refresh, selectedJob]);

	const getLoadList = async () => {
		try {
			setLoadingTable(true);
			const url = api + `/job/get/qc/loads/${selectedJob.id}`;

			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						ticket: item.deliveryTicket,
						truck: item.truck.number,
						loaded: item.toJobDate
							? dayjs(item.toJobDate)
									.add(5, "hour")
									.format("MM/DD/YYYY HH:mm A")
							: "-",
						arrival: item.toArriveDate
							? dayjs(item.toArriveDate)
									.add(5, "hour")
									.format("MM/DD/YYYY HH:mm A")
							: "-",
						ambient: item.ambientTemperature,
						wind: item.windSpeed,
						water: item.water,
						qcType: "Not QC",
						tested: item.qcData ? item.qcData.pourTestingComplete : false,
						pourTestingSlump: item.qcData
							? item.qcData.pourTestingSlump
							: undefined,
						pourTestingConcreteTemperature: item.qcData
							? item.qcData.pourTestingConcreteTemperature
							: undefined,
						pourTestingCylinders: item.qcData
							? item.qcData.pourTestingCylinders
							: undefined,
						pourTestingCylinderSize: item.qcData
							? item.qcData.pourTestingCylinderSize
							: undefined,
					});
				});
				setLoadList(list);
				setLoadingTable(false);
			} else {
				setLoadingTable(false);
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			openNotification("error", "Error", err.message);
			return null;
		}
	};

	return (
		<Modal
			title={`Job ID: ${selectedJob?.number}`}
			open={openModalNotQC}
			onCancel={() => {
				setSelectedJob(null);
				setOpenModalNotQC(false);
			}}
			footer={null}
			width={1500}
			centered
		>
			<Flex vertical gap={16}>
				<Button
					type="primary"
					onClick={() => setRefresh((prev) => !prev)}
					icon={<RetweetOutlined />}
					size="large"
					loading={loadingTable}
				/>
				<CustomTable
					columns={columnsLoads}
					data={loadList}
					loading={loadingTable}
				/>
			</Flex>
			{contextHolder}
			<QAQCAddNotQCDataInternal
				openModalForm={openModalForm}
				setOpenModalForm={setOpenModalForm}
				load={load}
				setLoad={setLoad}
				setRefresh={setRefresh}
				key={load ? load.id : "test"}
			/>
		</Modal>
	);
};

export default QAQCLoadsNotQC;
